const TOOL_LABELS: Record<string, string> = {
    get_page_map: 'Get page map',
    screenshot_section: 'Screenshot section',
    edit_section: 'Edit section',
    replace_image: 'Replace image',
    search_products: 'Search products',
    get_variant_sales: 'Get variant sales',
    swap_product: 'Swap product',
    add_product: 'Add product',
    remove_product: 'Remove product',
    feature_product: 'Feature product',
    change_section_products: 'Change products',
    add_collection_tile: 'Add collection tile',
    swap_collection_tile: 'Swap collection tile',
    remove_collection_tile: 'Remove collection tile',
    edit_collection_tile: 'Edit collection tile',
    change_collection_tiles: 'Change collection tiles',
    set_default_playlist: 'Set default playlist',
    remove_default_playlist: 'Remove default playlist',
    change_default_playlist: 'Change default playlist',
    change_carousel_videos: 'Change carousel videos',
    set_cta_action: 'Set CTA action',
    move_section: 'Move section',
    remove_section: 'Remove section',
    change_sections: 'Change sections',
    update_page_settings: 'Update page settings',
    list_placement_option_rules: 'List placement option rules',
    set_placement_option_rule: 'Set placement option rule',
    clear_placement_option_rules: 'Clear placement option rules',
    change_placement_option_rules: 'Change placement option rules',
    set_default_variant: 'Set default variant',
}

const TOOL_RUNNING_LABELS: Record<string, string> = {
    get_page_map: 'Reading page map',
    screenshot_section: 'Capturing section',
    edit_section: 'Editing section',
    replace_image: 'Replacing image',
    search_products: 'Searching products',
    get_variant_sales: 'Getting variant sales',
    swap_product: 'Swapping product',
    add_product: 'Adding product',
    remove_product: 'Removing product',
    feature_product: 'Featuring product',
    change_section_products: 'Changing products',
    add_collection_tile: 'Adding collection tile',
    swap_collection_tile: 'Swapping collection tile',
    remove_collection_tile: 'Removing collection tile',
    edit_collection_tile: 'Editing collection tile',
    change_collection_tiles: 'Changing collection tiles',
    set_default_playlist: 'Setting default playlist',
    remove_default_playlist: 'Removing default playlist',
    change_default_playlist: 'Changing default playlist',
    change_carousel_videos: 'Changing carousel videos',
    set_cta_action: 'Setting CTA action',
    move_section: 'Moving section',
    remove_section: 'Removing section',
    add_section: 'Adding section',
    change_sections: 'Changing sections',
    update_page_settings: 'Updating page settings',
    list_placement_option_rules: 'Listing placement option rules',
    set_placement_option_rule: 'Setting placement option rule',
    clear_placement_option_rules: 'Clearing placement option rules',
    change_placement_option_rules: 'Changing placement option rules',
    set_default_variant: 'Setting default variant',
}

function formatToolName(toolName: string): string {
    return toolName.replace(/_/g, ' ')
}

export function getToolLabel(toolName: string): string {
    return TOOL_LABELS[toolName] ?? formatToolName(toolName)
}

export function getToolRunningLabel(toolName: string): string {
    return TOOL_RUNNING_LABELS[toolName] ?? `${formatToolName(toolName)}…`
}
